var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 172,
    viewBox: "0 0 339 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_410_618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.814 -120.664C131.297 -126.122 138.144 -127.957 143.023 -124.471L163.868 -109.578C167.18 -107.211 171.631 -107.211 174.943 -109.578L195.787 -124.471C200.666 -127.957 207.514 -126.122 209.996 -120.664L220.601 -97.3439C222.287 -93.6379 226.141 -91.4126 230.193 -91.8061L255.691 -94.2818C261.66 -94.8613 266.673 -89.8484 266.093 -83.88L263.617 -58.382C263.224 -54.3298 265.449 -50.4755 269.155 -48.7902L292.475 -38.1852C297.934 -35.7029 299.768 -28.8551 296.282 -23.9761L281.389 -3.13198C279.022 0.180589 279.022 4.63116 281.389 7.94372L296.282 28.7878C299.768 33.6668 297.934 40.5146 292.475 42.9969L269.155 53.6019C265.449 55.2872 263.224 59.1415 263.617 63.1937L266.093 88.6918C266.673 94.6601 261.66 99.6731 255.691 99.0936L230.193 96.6178C226.141 96.2244 222.287 98.4497 220.601 102.156L209.996 125.475C207.514 130.934 200.666 132.769 195.787 129.283L174.943 114.39C171.631 112.023 167.18 112.023 163.868 114.39L143.023 129.283C138.144 132.769 131.297 130.934 128.814 125.476L118.209 102.156C116.524 98.4497 112.67 96.2244 108.618 96.6178L83.1195 99.0936C77.1512 99.6731 72.1382 94.6601 72.7177 88.6918L75.1935 63.1937C75.5869 59.1416 73.3616 55.2872 69.6556 53.6019L46.3358 42.9969C40.8773 40.5146 39.0424 33.6668 42.5285 28.7878L57.4215 7.94371C59.7884 4.63115 59.7884 0.180586 57.4215 -3.13198L42.5285 -23.9761C39.0424 -28.8551 40.8773 -35.7029 46.3358 -38.1852L69.6556 -48.7902C73.3616 -50.4755 75.5869 -54.3298 75.1935 -58.382L72.7177 -83.88C72.1382 -89.8484 77.1512 -94.8613 83.1195 -94.2818L108.618 -91.8061C112.67 -91.4126 116.524 -93.6379 118.209 -97.3439L128.814 -120.664Z",
    fill: "#FE7B51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_410_618",
    x: 32.5426,
    y: -131.721,
    width: 273.726,
    height: 273.726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.736
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.104
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_410_618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_410_618",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6374af6fd29e66247f1a00045efb1768.svg";
export { ForwardRef as ReactComponent };